import React from 'react';

interface TierCardProps {
  tierNumber: string;
  name: string;
  price: string;
  duration: string;
  format: string;
  deliverables: string[];
  bestFitIf: string;
  anchor: string;
}

const TierCard: React.FC<TierCardProps> = ({
  tierNumber, name, price, duration, format, deliverables, bestFitIf, anchor
}) => (
  <article
    id={anchor}
    className="bg-void-black border border-grid-line p-8 flex flex-col transition-colors hover:border-command-amber"
  >
    <div className="font-mono text-2xl text-command-amber font-semibold mb-4">{tierNumber}</div>
    <h2 className="text-2xl font-bold text-signal-white mb-4">{name}</h2>
    <div className="font-mono text-2xl md:text-3xl text-signal-white mb-1 whitespace-nowrap" style={{ fontFeatureSettings: '"tnum"' }}>{price}</div>
    <div className="font-mono text-xs text-steel uppercase tracking-[0.15em] mb-1">{duration}</div>
    <div className="font-mono text-xs text-steel uppercase tracking-[0.15em] mb-6">{format}</div>
    <ul className="space-y-2 mb-6 flex-1">
      {deliverables.map((d, i) => (
        <li key={i} className="text-steel text-sm flex gap-2"><span className="text-command-amber">-</span><span>{d}</span></li>
      ))}
    </ul>
    <div className="border-t border-grid-line pt-4">
      <div className="font-mono text-xs text-command-amber uppercase tracking-[0.15em] mb-2">Best fit if</div>
      <p className="text-steel text-sm">{bestFitIf}</p>
    </div>
  </article>
);

export default TierCard;
